
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc, 
  query, 
  where, 
  orderBy, 
  limit,
  Timestamp 
} from 'firebase/firestore';
import { db } from './firebase/config';
import { CommunityEvent } from '../types/events';

const COLLECTION = 'events';

export const eventsService = {
  // Criar evento
  createEvent: async (event: Omit<CommunityEvent, 'id' | 'createdAt' | 'updatedAt' | 'status'>): Promise<string> => {
    const now = new Date();
    const isTenant = event.organizerType === 'tenant';
    
    const newEvent = {
      ...event,
      status: isTenant ? 'approved' : 'pending', // Tenants são aprovados automaticamente
      isVerified: isTenant,
      createdAt: now,
      updatedAt: now
    };

    const docRef = await addDoc(collection(db, COLLECTION), newEvent);
    return docRef.id;
  },

  // Listar eventos aprovados (Público)
  getPublicEvents: async (filter?: { state?: string; type?: string }): Promise<CommunityEvent[]> => {
    let q = query(
      collection(db, COLLECTION), 
      where('status', '==', 'approved'),
      where('endDate', '>=', new Date()), // Apenas eventos futuros ou em andamento
      orderBy('endDate', 'asc'),
      orderBy('startDate', 'asc')
    );

    if (filter?.state) {
      q = query(q, where('location.state', '==', filter.state));
    }
    
    if (filter?.type) {
      q = query(q, where('type', '==', filter.type));
    }

    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      startDate: (doc.data().startDate as Timestamp).toDate(),
      endDate: (doc.data().endDate as Timestamp).toDate(),
      createdAt: (doc.data().createdAt as Timestamp).toDate(),
      updatedAt: (doc.data().updatedAt as Timestamp).toDate(),
    } as CommunityEvent));
  },

  // Busca por ID
  getEventById: async (id: string): Promise<CommunityEvent | null> => {
    const docRef = doc(db, COLLECTION, id);
    const snapshot = await getDoc(docRef);
    
    if (!snapshot.exists()) return null;
    
    const data = snapshot.data();
    return {
      id: snapshot.id,
      ...data,
      startDate: (data.startDate as Timestamp).toDate(),
      endDate: (data.endDate as Timestamp).toDate(),
      createdAt: (data.createdAt as Timestamp).toDate(),
      updatedAt: (data.updatedAt as Timestamp).toDate(),
    } as CommunityEvent;
  },

  // Listar eventos de um organizador (Tenant)
  getOrganizerEvents: async (organizerId: string): Promise<CommunityEvent[]> => {
    const q = query(
      collection(db, COLLECTION),
      where('organizerId', '==', organizerId),
      orderBy('createdAt', 'desc')
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      startDate: (doc.data().startDate as Timestamp).toDate(),
      endDate: (doc.data().endDate as Timestamp).toDate(),
      createdAt: (doc.data().createdAt as Timestamp).toDate(),
      updatedAt: (doc.data().updatedAt as Timestamp).toDate(),
    } as CommunityEvent));
  }
};
